
<template>
	<div class="bookingtable-component">
		<table class="table table-striped table-light table-hover">
			<thead class="thead-dark">
				<tr>
					<td>{{ $t('booking.bookingtable.tableheader.arrivalday') }}</td>
					<td>{{ $t('booking.bookingtable.tableheader.departureday') }}</td>
					<td>{{ $t('booking.bookingtable.tableheader.gender') }}</td>
					<td>{{ $t('booking.bookingtable.tableheader.firstname') }}</td>
					<td>{{ $t('booking.bookingtable.tableheader.lastname') }}</td>
					<td>{{ $t('booking.bookingtable.tableheader.zip') }}</td>
					<td>{{ $t('booking.bookingtable.tableheader.city') }}</td>
					<td>{{ $t('booking.bookingtable.tableheader.birthday') }}</td>
					<td>{{ $t('booking.bookingtable.tableheader.company') }}</td>
					<td>{{ $t('booking.bookingtable.tableheader.roomcategory') }}</td>
					<td v-if="false">{{ $t('booking.bookingtable.tableheader.roomnumber') }}</td>
					<td>{{ $t('booking.bookingtable.tableheader.keyboycode') }}</td>
					<td>&nbsp;</td>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(booking, k) in this.$parent.allBookings" v-show="showBookingTable">
					<td>
						<div v-if="!booking.editing" @dblclick="editBooking(booking)">{{ booking.arrivalDay | dateFormat}}</div>
						<div v-else><date-picker placeholder="Select Date" :format="customFormatter" v-model="booking.arrivalDay"></date-picker></div>
					</td>
					<td>
						<div v-if="!booking.editing" @dblclick="editBooking(booking)">{{ booking.departureDay | dateFormat}}</div>
						<div v-else><date-picker placeholder="Select Date" :format="customFormatter" v-model="booking.departureDay"></date-picker></div>
					</td>
					<td>
						<div v-if="!booking.editing" @dblclick="editBooking(booking)">
							<span v-if="booking.gender == 1">
							{{ $t('booking.bookingtable.tableheader.genders.mrs') }}
							</span>
							<span v-if="booking.gender == 2">
							{{ $t('booking.bookingtable.tableheader.genders.mr') }}
							</span>
              <span v-else></span>
						</div>
						<div v-else>
							<select v-model="booking.gender" class="form-control"><option value=""></option><option value="1">{{ $t('booking.bookingtable.tableheader.genders.mrs') }}</option><option value="2">{{ $t('booking.bookingtable.tableheader.genders.mr') }}</option></select></div>
					<td>
						<div v-if="!booking.editing" @dblclick="editBooking(booking)">{{ booking.firstname}}</div>
						<div v-else><input type="text" @keyup.enter="endEditBooking(booking)"
															v-model="booking.firstname" class="form-control"/></div>
					</td>
					<td>
						<div v-if="!booking.editing" @dblclick="editBooking(booking)">{{ booking.lastname}}</div>
						<div v-else><input type="text" @keyup.enter="endEditBooking(booking)"
															v-model="booking.lastname" class="form-control"/></div>
					</td>
					<td>
						<div v-if="!booking.editing" @dblclick="editBooking(booking)">{{ booking.zip}}</div>
						<div v-else><input type="text" @keyup.enter="endEditBooking(booking)"
															v-model="booking.zip" class="form-control"/></div>
					</td>
					<td>
						<div v-if="!booking.editing" @dblclick="editBooking(booking)">{{ booking.city}}</div>
						<div v-else><input type="text" @keyup.enter="endEditBooking(booking)"
															v-model="booking.city" class="form-control"/></div>
					</td>
					<td>
						<div v-if="!booking.editing" @dblclick="editBooking(booking)">{{ booking.birthday | dateFormat}}</div>
						<div v-else><date-picker placeholder="Select Date" :format="customFormatter" v-model="booking.birthday"></date-picker></div>
					</td>
          <td>
						<div v-if="!booking.editing" @dblclick="editBooking(booking)">{{ booking.company}}</div>
						<div v-else><input type="text" @keyup.enter="endEditBooking(booking)"
															v-model="booking.company" class="form-control"/></div>
					</td>
					<td>
						<div v-if="!booking.editing" @dblclick="editBooking(booking)">{{ booking.roomCategory}}</div>
						<div v-else>
							<select v-model="booking.roomCategory" class="form-control"><option v-for="room in getAllRooms()">{{room.roomNumber}} - {{room.roomCategory}}</option></select>
						</div>
					</td>
					<td v-if="false">
						<div v-if="!booking.editing" @dblclick="editBooking(booking)">{{ booking.roomNumber}}</div>
						<div v-else><input type="text" @keyup.enter="endEditBooking(booking)"
															v-model="booking.roomNumber" class="form-control"/></div>
					</td>
					<td>
						<div v-if="!booking.editing" @dblclick="editBooking(booking)">{{ booking.keyBoyCode}}</div>
						<div v-else><input type="text" @keyup.enter="endEditBooking(booking)"
															v-model="booking.keyBoyCode" class="form-control"/></div>
					</td>
					<td>
						<div v-if="!booking.editing">
							<button @click="editBooking(booking)" class="btn btn-secondary mr-2">{{ $t('booking.bookingtable.tablebuttons.edit') }}</button>
							<button @click="removeBooking(k, booking)" class="btn btn-danger">{{ $t('booking.bookingtable.tablebuttons.delete') }}</button>
						</div>
						<div v-if="booking.editing">
							<button @click="endEditBooking(booking)" class="btn btn-success">{{ $t('booking.bookingtable.tablebuttons.ok') }}</button>
						</div>
					</td>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<td><date-picker input-class="form-control" placeholder="Select Date" :value="new Date()" :format="customFormatter" v-model="arrivalday"></date-picker></td>
					<td><date-picker input-class="form-control" placeholder="Select Date" :value="new Date()" :format="customFormatter" v-model="departureday"></date-picker></td>
					<td><select v-model="gender" class="form-control"><option value=""></option><option value="1">{{ $t('booking.bookingtable.tableheader.genders.mrs') }}</option><option value="2">{{ $t('booking.bookingtable.tableheader.genders.mr') }}</option></select></td>
					<td><input type="text" v-model="firstname" class="form-control"/></td>
					<td><input type="text" v-model="lastname" class="form-control"/></td>
					<td><input type="text" v-model="zip" class="form-control"/></td>
					<td><input type="text" v-model="city" class="form-control"/></td>
					<td><date-picker input-class="form-control" placeholder="Select Date" :value="new Date()" :format="customFormatter" v-model="birthday"></date-picker></td>
					<td><select v-model="roomcategory" class="form-control"><option v-for="room in getAllRooms()">{{room.roomNumber}} - {{room.roomCategory}}</option></select></td>
					<td v-if="false"><input type="text" v-model="roomnumber" class="form-control"/></td>
					<td><input type="text" v-model="keyBoyCode" class="form-control"/></td>
					<td>
						<button @click="addBooking"  class="btn btn-primary">{{ $t('booking.bookingtable.tablebuttons.addbooking') }}</button>
					</td>
				</tr>
			</tfoot>
		</table>

		<div v-show="show_error_text">Bitte füllen Sie die Zimmerkategorie, Zimmer nummer und den KeyBoyCode aus!</div>

    <div class="text-center">
      <p>
        <button @click.prevent="$parent.generateEmptyBookings()">Fülle restliche Zimmer mit Spontanbuchungen auf.</button><br />
      </p><p>
        <button @click.prevent="$parent.removeAllBookings()">Alle Daten löschen (VORSICHT !!!)</button>
      </p>
    </div>


	</div>
</template>

<script>

	import axios from 'axios'
	import Stringify from 'vue-stringify'
	import DatePicker from 'vuejs-datepicker'
	import moment from 'moment'
	import { mapState } from 'vuex';

	export default {
		props: [],
		data: function () {
			return {

				bookingday: null,
				arrivalday: '',
				departureday: '',
				gender: null,
				firstname: null,
				lastname: null,
				zip: null,
				city: null,
				birthday: null,
        		company: null,
				roomcategory: null,
				roomnumber: null,
				keyBoyCode: null,

				lastItem: null,
				showBookingTable: false,

				show_error_text: false,
			}
		},
		computed: {
			...mapState('settings', ['config']),
		},
		filters: {
			dateFormat(value) {
				if (value) {
					return moment(String(value)).format('DD.MM.YYYY') != 'Invalid date' ? moment(String(value)).format('DD.MM.YYYY') : value;
				}
			}
		},
		mounted: function() {
			if( typeof this.$parent.allBookings !== 'undefined') {
				this.showBookingTable = true;
			}
		},
		directives: {
			focus: {
				// directive definition
				inserted: function (el) {
					el.focus()
				}
			}
		},
		methods: {

			/** Set format for datepicker date **/
			customFormatter: function(date) {
				return moment(date).format('DD.MM.YYYY');
			},
			getCurrentDate: function() {
				let currentDate = new Date();
				// console.log(currentDate);
				return currentDate;
			},

			/** Add booking entry **/
			addBooking: function () {
				// console.log(this.$parent.allBookings);

				if(!this.roomcategory && !this.keyBoyCode) {
					this.show_error_text = true;
					return false;
				} else {
					this.show_error_text = false;
				}

				let newBooking = {
					id: 'new',
          			arrivalDay: this.arrivalday,
         			departureDay: this.departureday,
					bookingDay: this.bookingday,
					gender: this.gender !='' ? this.gender : '',
					firstname: this.firstname,
					lastname: this.lastname,
					zip: this.zip,
					city: this.city,
					birthday: this.birthday,
          			company: this.company,
					roomCategory: this.roomcategory,
					roomNumber: this.roomnumber,
					keyBoyCode: this.keyBoyCode,
					editing: false
				};
				this.$parent.allBookings.push(newBooking);


				this.arrivalday = '';
				this.departureday = '';
				this.bookingday = '';
				this.gender = '';
				this.firstname = '';
				this.lastname = '';
				this.zip = '';
				this.city = '';
				this.birthday = '';
        		this.company = '';
				this.roomcategory = '';
				this.roomnumber = '';
				this.keyBoyCode = '';

				this.$parent.saveAllBookings();
			},

			/** Remove booking entry **/
			removeBooking: function (k, booking) {

				var isDelete = confirm("Sind Sie sicher (die Daten sind nach dem Löschen verloren) ?");
				if (isDelete) {
					let idx = this.$parent.allBookings.indexOf(booking);
					this.$parent.allBookings.splice(idx, 1);

					let formData = new FormData();
					formData.append('bookingToRemove', JSON.stringify(booking));

					axios({
						method: 'post',
						url: this.config.apiUrl + 'removeBooking',
            			withCredentials: true,
						data: formData
					}).then(response => (true))
				}
			},

			/** Edit booking entry **/
			editBooking: function (booking) {
				if (this.lastItem) {
					this.lastItem.editing = false;
				}
				this.lastItem = booking;
				booking.editing = true;
			},

			/** Finish edit booking entry **/
			endEditBooking: function (booking) {
				booking.editing = false;
				this.$parent.saveAllBookings();
			},

			/** getAllRoomCategories **/
			getAllRoomCategories: function() {
				return this.$parent.allRoomCategories;
			},

			getAllRooms: function() {
				return this.$parent.allRooms;
			},

			debug: function(value) {
				console.log(value);
			}

		},
		components: {
			DatePicker
		}
	}
</script>

<style scoped lang="scss">
	.bookingtable-component table td {
		cursor: pointer;
		vertical-align: middle;
	}

	.bookingtable-component table thead th,
	.bookingtable-component table tbody td:last-child,
  .bookingtable-component table tfoot td:last-child {
		white-space: nowrap;
    text-align: right;
	}

	.bookingtable-component table thead td {
		background-color: #383639;
		color: #fff;
		font-family: 'BrandonGrotesque-Bold';
		border-top: 1px solid #383639;
	}

	.bookingtable-component table tfoot td {
		background-color: #d5d5d6;
	}

	.bookingtable-component .btn {
		border-radius: 0;
	}
</style>

<style lang="scss">
	body {
		overflow: auto;
	}

	.bookingtable-component .form-control {
		font-size: 1rem;
		padding: .125rem;
		-webkit-box-shadow: none;
		box-shadow: none;
		background: #fff;
		letter-spacing: 0;
	}

	.bookingtable-component .form-control:hover,
	.bookingtable-component .form-control:focus,
	.bookingtable-component .form-control:active {
		background: #fff;
	}
</style>
